// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Container } from '@components/app/Layout'

// Styles
import styles from './Media.module.sass'

// Data
import media from '@data/media.json'

const Media = ({ bottom = false }: { bottom?: boolean }) => {
  return (
    <section className={`${styles.media} ${bottom ? styles['bottom'] : ''}`}>
      <Container>
        <div className={styles.media__swiper}>
          {media.map(({ url, width, height, link }, index) => (
            <Link
              href={link}
              target="_blank"
              className={styles.media__swiper__logo}
              key={index}
            >
              <Image src={url} width={width} height={height} alt={url} />
            </Link>
          ))}
          {media.map(({ url, width, height, link }, index) => (
            <Link
              href={link}
              target="_blank"
              className={styles.media__swiper__logo}
              key={index}
            >
              <Image
                src={url}
                width={width}
                height={height}
                priority
                alt={url}
              />
            </Link>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default Media
